/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

var Navigation = (function (_Component) {
	_inherits(Navigation, _Component);

	_createClass(Navigation, null, [{
		key: 'propTypes',
		value: {
			'links': _react.PropTypes.object,
			'className': _react.PropTypes.string,
			'selected': _react.PropTypes.string,
			'navSections': _react.PropTypes.array,
			'navSeries': _react.PropTypes.array
		},
		enumerable: true
	}]);

	function Navigation(props) {
		_classCallCheck(this, _Navigation);

		_Component.call(this, props);
		this.state = {
			'isStuck': false
		};
	}

	Navigation.prototype.render = function render() {
		var styles = require('./Navigation.css');

		return _react2['default'].createElement(
			'div',
			{ className: (this.props.className ? this.props.className + ' ' : null) + styles.Base },
			_react2['default'].createElement(
				'div',
				{ className: styles.NavLeft },
				_react2['default'].createElement(_components.ExpandingMenu, {
					className: styles.Item,
					icon: 'hamburger',
					label: 'Sections',
					links: this.props.navSections,
					rootURI: '/section',
					selected: this.props.selected
				}),
				_react2['default'].createElement(_components.ExpandingMenu, {
					className: styles.Item + ' ' + styles['Item--withDivider'],
					icon: null,
					label: 'Special Series',
					links: this.props.navSeries,
					rootURI: '/special-series',
					seeAllLink: '/special-series',
					selected: this.props.selected
				})
			),
			_react2['default'].createElement(
				'div',
				{ className: styles.NavRight },
				_react2['default'].createElement(
					'nav',
					{ className: styles.SocialNav },
					_react2['default'].createElement(
						'ul',
						null,
						_react2['default'].createElement(
							'li',
							{ className: styles.SocialLinks + ' ' + styles['SocialLinks--facebook'] },
							_react2['default'].createElement(
								'a',
								{ href: _srcSettings2['default'].links.facebook },
								'Facebook'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.SocialLinks + ' ' + styles['SocialLinks--twitter'] },
							_react2['default'].createElement(
								'a',
								{ href: _srcSettings2['default'].links.twitter },
								'Twitter'
							)
						)
					)
				),
				_react2['default'].createElement(
					_components.ExpandingMenu,
					{
						className: styles.Item,
						label: 'Support Us',
						icon: null,
						narrowLabel: true,
						menuPosition: 'alignRight',
						isMenu: false,
						selected: this.props.selected },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ className: styles.SupportMessage, to: '/membership' },
						'The Brew is an independent non-profit news organization. ',
						_react2['default'].createElement(
							'strong',
							null,
							'Become a member!'
						)
					)
				),
				_react2['default'].createElement(_components.SearchMenu, {
					className: styles.Item + ' ' + styles.SearchNav,
					label: 'Search' })
			)
		);
	};

	var _Navigation = Navigation;
	Navigation = _reactRedux.connect(function (state) {
		return {
			navSections: state.navSections.data,
			navSeries: state.navSpecialSeries.data
		};
	})(Navigation) || Navigation;
	return Navigation;
})(_react.Component);

exports['default'] = Navigation;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Navigation/Navigation.js
 ** module id = 686
 ** module chunks = 0
 **/